import { AuthTypes } from 'enums';

/**
 * isUserAuthenticated - Verifies if the current userAuth array matches a given provider.
 * For `ESPN_PLUS`, we rely that the match is not `MVPD` and not `ISP`. If the result of .find returns
 * a non-empty array we assume a match is found.
 *
 * @param {array} userAuth - An array holding the current user authentication state; can have more than one
 * @param {string} provider - A string used to represent the authentication provider (MVPD, BAM or ISP)
 *
 * @return {boolean} Returns a boolean flag based on finding a match between the userAuth array and given provider
 */
export default function isUserAuthenticated(userAuth = [], provider = '') {
    if (userAuth.length === 0 || typeof provider !== 'string' || provider.trim() === '') {
        return false;
    }

    let userIsAuthenticated;
    if (provider === AuthTypes.BAM) {       
        userIsAuthenticated = userAuth.filter(auth => auth.indexOf(AuthTypes.MVPD) === -1 && auth.indexOf(AuthTypes.ISP) === -1);    
    } else {      
        userIsAuthenticated = userAuth.filter(auth => auth.indexOf(provider) !== -1);
    }

    if (userIsAuthenticated.length) {
        return true;
    }

    return false;
}



// WEBPACK FOOTER //
// ./app/lib/auth/isUserAuthenticated.js